<template>
  <div class="d-flex justify-content-center mb-5">
    <b-container>
      <b-row>
        <b-col v-if="!loaded && !showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('note.error') }}</p>
          </b-card>
        </b-col>
      </b-row>
<!--      <div v-for="(notes, date) in data" :key="date" class="w-100 notes-container">-->
<!--        <div @click="toggleCollapse(date)" class="note-date text-center text-light p-2">{{ formatDate(date) }}</div>-->
<!--        <b-collapse :id="'notes-' + date" accordion="notes">-->
<!--          <b-card>-->
<!--            <div class="mb-3" v-for="(note, i) in notes" :key="i">-->
<!--              <div class="d-flex justify-content-between">-->
<!--                <div class="note-text">{{ note.text }}</div>-->
<!--                <b-link class="text-body icon-pen text-decoration-none" :title="$t('note_edit.title')" @click="checkNetworkUpdateNote(note.id)" ></b-link>-->
<!--              </div>-->
<!--            </div>-->
<!--          </b-card>-->
<!--        </b-collapse>-->
<!--      </div>-->
      <div class="d-flex flex-wrap">
        <b-col class="mb-3 col-md-6 col-sm-12 col-12 col-lg-3" v-for="(notes, date) in data" :key="date">
              <b-card
                border-variant="Dark"
                :header="formatDate(date)"
                header-bg-variant="transparent"
                align="center"
                class="h-100"
              >
                <b-card-body>
                <div class="mb-3" v-for="(note, i) in notes" :key="i">
                  <div class="d-flex justify-content-between note-text">
                    <div class="text-body text-center w-100 card-text">
                      {{ note.text }}
                    </div>
                    <b-link class="text-body icon-pen text-decoration-none edit-button" :title="$t('note_edit.title')" @click="checkNetworkUpdateNote(note.id)" ></b-link>
                  </div>
<!--                  <b-card-text class="col-11">{{ note.text }}</b-card-text>-->
<!--                    <b-link class="col-1 text-body icon-pen text-decoration-none edit-button" :title="$t('note_edit.title')" @click="checkNetworkUpdateNote(note.id)" ></b-link>-->
                  </div>
                </b-card-body>
              </b-card>
        </b-col>
      </div>
      <b-modal :id="'offLineModalNoteUpdate'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NoteList',
  props: ['id', 'apiary'],
  data () {
    return {
      showError: false,
      data: null,
      deleteClicked: null
    }
  },
  computed: {
    loaded () {
      return !!this.data
    }
  },
  methods: {
    checkNetworkUpdateNote (noteId) {
      if (navigator.onLine) {
        this.$router.replace('/note/edit/' + noteId + '/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalNoteUpdate')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalNoteUpdate')
    },
    formatDate (date) {
      return moment(date).format('DD[.]MM[.]YYYY')
    },
    toggleCollapse (date) {
      this.$root.$emit('bv::toggle::collapse', 'notes-' + date)
    },
    async loadData () {
      try {
        const notes = await this.$api.notes.getAll(this.id) || []
        const notesByDate = {}
        // sort by id
        notes.sort(function (rowA, rowB) {
          if (rowA.id < rowB.id) {
            return 1
          }
          if (rowA.id > rowB.id) {
            return -1
          }
          return 0
        })
        // sort by date
        notes.sort(function (rowA, rowB) {
          if (rowA.date < rowB.date) {
            return 1
          }
          if (rowA.date > rowB.date) {
            return -1
          }

          return 0
        }).forEach(function (row) {
          notesByDate[row.date] = notesByDate[row.date] || []
          notesByDate[row.date].push(row)
        })

        this.data = notesByDate
        // this.data = notes
      } catch (e) { // network error etc.
        this.data = null
      }

      this.showError = !this.data
      return this.data
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .notes-container:nth-child(2n) {
    .note-date {
      background-color: $primary;
    }
  }

  .notes-container:nth-child(2n + 1) {
    .note-date {
      background-color: $primary-dark;
    }
  }

  .notes-container {
    font-family: $font-family-sans-serif;
  }
  //.text-body {
  //  font-size: 1.25rem;
  //}
  .note-text {
    word-wrap: break-word;
    word-break: break-all;
  }
  .card-body {
    padding: 1.25rem;
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }
  .card {
    border: 1px solid;
    font-family: $font-family-sans-serif;
  }
  .card-header {
    font-weight: bold;
    padding: 0.25rem 1.25rem;
  }
  .card-body{
   padding: 1rem 0.25rem;
    font-family: $font-family-sans-serif;
  }
  .edit-button {
    right: 0.5rem;
    font-size: 1.25rem;
  }
</style>
